
import { Vue, Component, Prop } from "vue-property-decorator";
import vue100vh from "vue-100vh";

@Component({
  components: {
    vue100vh
  }
})
export default class SearchAdvanced extends Vue {
  @Prop(Function) close!: any;

  optionsDate = ["Menor a 15 días", "Todos"];
  optionsArea = [];
  optionsExperience = [];
  optionsPlaces = [];

  selectedPosition = "";
  selectedArea = "";
  selectedDate = "";
  selectCountry = "";

  location_status = false;

  radioBt = "full-time";
  experience = null;

  valueSlider = 5;
  msjSlot = "Escribe una ubicacion";

  optionsSlider = {
    interval: 5,
    dotSize: 20,
    max: 50
  };

  async mounted() {
    (this as any).optionsArea = (
      await (this as any).$root._get("area", {})
    ).data.map((item: any) => {
      return { label: item.description, value: item.id };
    });
    (this as any).selectedDate = "Menor a 15 días";
    (this as any).optionsExperience = (this as any).$root.experiences;
  }

  async fetchOptions(search: any, loading: any) {
    if (search.length > 2) {
      loading(true);
      const response = await (this as any).$root._get(
        `misc/locations?q=${search}&addp=1`,
        {}
      );
      (this as any).optionsPlaces = response;
      loading(false);
      if (response.length === 0) {
        (this as any).msjSlot = "Lo sentimos, no hay resultados.";
      }
    } else {
      this.msjSlot = "Escribe una ubicacion";
    }
  }

  validateNumber(event: any) {
    let charCode = event.which ? event.which : event.keyCode;

    if (
      (charCode >= 48 && charCode <= 57) ||
      charCode === 9 ||
      charCode === 13 ||
      (charCode >= 35 && charCode <= 46)
    ) {
      if (
        parseInt(event.target.value + String.fromCharCode(charCode), 10) <=
          50 &&
        event.target.value <= 50
      ) {
        return true;
      }
    }
    event.preventDefault();
    event.stopPropagation();
  }

  search() {
    let word = (this as any).selectedPosition
      ? (this as any).selectedPosition
      : "-";
    let newDate = (this as any).selectedDate ? (this as any).selectedDate : "-";
    let newArea = (this as any).selectedArea
      ? (this as any).selectedArea.value
      : "-";
    let newCountry = (this as any).selectCountry.id
      ? (this as any).selectCountry.id
      : "-";
    let newExperience = (this as any).experience
      ? (this as any).experience
      : "-";
    (this as any).$router.push(
      "/ofertas/" +
        word.replace(/ /g, "-").toLowerCase() +
        "/" +
        newDate.replace(/ /g, "-").toLowerCase() +
        "/" +
        newArea +
        "/" +
        (this as any).radioBt.replace(/ /g, "-").toLowerCase() +
        "/" +
        newCountry +
        "/" +
        (this as any).valueSlider +
        "/" +
        newExperience
    );
  }

  created() {
    document.body.classList.add("scroll-lock");
  }

  destroyed() {
    document.body.classList.remove("scroll-lock");
    document.body.classList.remove("scroll-lock-with-fix");
  }
}
